import { autoinject, computedFrom } from 'aurelia-framework';
import { FormattingHelper } from '../../../helpers/formatting-helper';
import { State } from '../../../services/global-state';
import { ValidationHelpers } from '../../../services/validation-helpers';
import { I18N } from 'aurelia-i18n';

@autoinject
export class CheckFormCustomElement {
	accountTypes: any[];
	globalState: State;
	checkData: any;
	selectAccountTypeSettings: any;
	bankAccountNumberSettings: any;
	bankAccountNumberVerificationSettings: any;
	bankTransitNumberSettings: any;
	checkNumberSettings: any;

	constructor(globalState: State, private i18n:I18N) {
		this.accountTypes = [
			{
				value: "checking",
				description: this.i18n.i18next.t('personalCheckingAccount', 'Personal Checking Account')
			},
			{
				value: "savings",
				description: this.i18n.i18next.t('personalSavingsAccount', 'Personal Savings Account')
			},
			{
				value: "business",
				description: this.i18n.i18next.t('businessCheckingAccount', 'Business Checking Account')
			}
		];
		this.globalState = globalState;
	}

	//TODO: Chris - add computedFrom
	get validate() {
		return this.checkData && this.checkData.validate;
	}

	//TODO: Chris - add computedFrom
	get transitNumberColumns() {
		return "col-sm-6";
	}

	//TODO: Chris - add computedFrom
	get accountNumberColumns() {
		return "col-sm-6";
	}

	@computedFrom('accountTypes')
	get accountDescriptions(): string[] {
		return this.accountTypes.map(a => (a?.description || ''));
	}

	@computedFrom('accountTypes')
	get accountTypesIds(): string[] {
		return this.accountTypes.map(a => (a?.value || ''));
	}

	activate(checkData) {
		this.checkData = checkData;

		if (this.checkData.isRehabPaymentPlanForm)
			this.accountTypes.pop();

		this.selectAccountTypeSettings = this.globalState.business.portalSettings.fields.selectAccountType;
		if (!!this.selectAccountTypeSettings && !this.selectAccountTypeSettings.label) { this.selectAccountTypeSettings.label = this.i18n.i18next.t('selectAccountType', 'Select Account Type'); }

		this.bankAccountNumberSettings = this.globalState.business.portalSettings.fields.bankAccountNumber;
		if (!!this.bankAccountNumberSettings && !this.bankAccountNumberSettings.label) { this.bankAccountNumberSettings.label = this.i18n.i18next.t('bankAccountNumber', 'Bank Account Number'); }

		this.bankAccountNumberVerificationSettings = this.globalState.business.portalSettings.fields.bankAccountNumberVerification;
		if (!!this.bankAccountNumberVerificationSettings && !this.bankAccountNumberVerificationSettings.label) { this.bankAccountNumberVerificationSettings.label = this.i18n.i18next.t('bankAccountNumberVerification', 'Re-enter Bank Account Number'); }

		this.bankTransitNumberSettings = this.globalState.business.portalSettings.fields.bankTransitNumber;
		if (!!this.bankTransitNumberSettings && !this.bankTransitNumberSettings.label) { this.bankTransitNumberSettings.label = this.i18n.i18next.t('bankTransitNumber', 'Bank Transit Number'); }

		this.checkNumberSettings = this.globalState.business.portalSettings.fields.checkNumber;
		if (!!this.checkNumberSettings && !this.checkNumberSettings.label) { this.checkNumberSettings.label = this.i18n.i18next.t('checkNumber', 'Check Number'); }
	}
}

export class CheckFormData {
	globalState: State;
	transitNumber: any;
	accountNumber: any;
	accountNumberVerification: any;
	accountType: any;
	checkNumber: any;
	isRehabPaymentPlanForm: any;
	customFields: any;

	constructor(private i18n: I18N, globalState: State) {
		this.globalState = globalState;
		this.transitNumber = "";
		this.accountNumber = "";
		this.accountNumberVerification = "";
		this.checkNumber = "";
		this.accountType = "checking";
		this.isRehabPaymentPlanForm = false;
	}

	//TODO: Chris - add computedFrom
	@computedFrom('accountType', 'accountNumber')
	get description() {
		return `${this.accountType} account ending in ${FormattingHelper.mask(this.accountNumber)}`;
	}

	validate(errors) {
		if (this.transitNumber.length === 0) {
			errors.push(this.i18n.i18next.t('transitNumberRequired', 'Transit number is required'));
		} else if (!ValidationHelpers.isTransitNumber(this.transitNumber)) {
			errors.push(this.i18n.i18next.t('invalidTransitNumber', 'Invalid transit number'));
		}

		if (this.accountNumber.length === 0) {
			errors.push(this.i18n.i18next.t('bankAccountNumberRequired', 'Bank Account number is required'));
		} else if (!ValidationHelpers.isOnlyDigits(this.accountNumber)) {
			errors.push(this.i18n.i18next.t('bankAccountNumberCanContainOnlyDigits', 'Bank Account number can contain only digits'));
		} else if (!ValidationHelpers.isAchBankAccountNumber(this.accountNumber)) {
			errors.push(this.i18n.i18next.t('bankAccountNumberMustBe5To17Digits', 'Bank account number must be 5-17 digits'));
		}

		if (this.globalState.business.portalSettings.fields.bankAccountNumberVerification.visible
			&& this.globalState.business.portalSettings.fields.bankAccountNumberVerification.required
			&& this.accountNumberVerification != this.accountNumber) {
			errors.push(this.i18n.i18next.t('bankAccountNumbersDoNotMatch', 'Bank Account Numbers do not match'));
		}

		if (this.checkNumber.length === 0 && this.globalState.business.portalSettings.fields.checkNumber.required) {
			errors.push(this.i18n.i18next.t('checkNumberRequired', 'Check Number is required'));
		} else if (!ValidationHelpers.isOnlyDigits(this.checkNumber)) {
			errors.push(this.i18n.i18next.t('checkNumberCanContainOnlyDigits', 'Check Number can contain only digits'));
		}

		for (let ii = 0; ii < this.customFields.length; ++ii) {
			let field = this.customFields[ii];
			if (field.visible && field.required && (!field.value || field.value.length === 0)) {
				var label = field.label || `Custom Field ${ii + 1}`;
				errors.push(`${label} is required`);
			}
		}
	}

	mapAccountTypeToApi() {
		switch (this.accountType) {
			case "checking": return 1;
			case "savings": return 2;
			case "business": return 3;
		}
	}
}
